/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { dispatchTableLoader } from '../../../../SharedModules/Table/store/Actions';
import {
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  deselectedIcon,
  selectedIcon,
} from '../../../../SharedModules/pdfExport/ExportIcon';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const border = [false, false, false, false];

const getHeader = (currentPage, pageCount, data) => {
  const { prinDate, requestedBy, reportName, customObj, NDCBalance } = data;
  const widths = [260, 440, 260];
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [28.8, 20, 28.8, 25.92],
    style: 'tableExample',
    table: {
      widths,
      headerRows: 2,
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
          {
            text: reportName,
            fontSize: 13,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
            border,
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
            border,
          },
        ],
        [
          {
            text: [{ text: 'Rebate Program: ' }, 'All Rebate Programs'],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
          {
            columns: [
              {
                text: [{ text: 'Manufacturer: ' }, customObj?.mfgId],
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'right',
                bold: false,
                width: 150,
              },
              {
                text: [{ text: 'Name: ' }, customObj?.mfgName],
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'left',
                bold: false,
              },
            ],
            fontSize: 10,
            fontFamily: 'arial',
            columnGap: 20,
            border,
          },

          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
            border,
          },
        ],
        [
          {
            text: [{ text: 'Quarter: ' }, customObj?.quarter],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            bold: false,
            border,
          },
          {
            columns: [
              {
                text: [{ text: 'URA Used: ' }, customObj?.URAUsed],
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'right',
                bold: false,
                width: 150,
              },
              {
                text: '',
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'left',
                bold: false,
              },
            ],
            fontSize: 10,
            fontFamily: 'arial',
            columnGap: 20,
            border,
          },

          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
        ],
        [
          {
            text: 'NDC Balance: ',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
        ],
        [
          {
            columns: [
              {
                columns: [
                  {
                    text: 'Balance Due:',
                    fontSize: 10,
                    fontFamily: 'arial',
                    alignment: 'left',
                    bold: false,
                  },
                  {
                    svg: NDCBalance.balanceDue ? selectedIcon : deselectedIcon,
                    width: 12,
                    height: 12,
                    alignment: 'left',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: ' Overridden: ',
                    fontSize: 10,
                    fontFamily: 'arial',
                    alignment: 'center',
                    bold: false,
                  },
                  {
                    svg: NDCBalance.overidden ? selectedIcon : deselectedIcon,
                    width: 12,
                    height: 12,
                    alignment: 'left',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: ' Paid in Full: ',
                    fontSize: 10,
                    fontFamily: 'arial',
                    alignment: 'center',
                    bold: false,
                  },
                  {
                    svg: NDCBalance.paidInFull ? selectedIcon : deselectedIcon,
                    width: 12,
                    height: 12,
                    alignment: 'left',
                  },
                ],
              },
            ],
            colSpan: 1,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            border,
          },
        ],
      ],
    },
    // layout: 'noBorders',
  };
  return header;
};

const contentFont = 10;
const pageMargins = [28.8, 130, 28.8, 25.92];

const valueFormatter = (value) => {
  const cellValue = removeDollarForNumberFiled(
    removeCommaForNumberFiled(value || 0)
  )?.trim();
  if (cellValue < 0) {
    return `($ ${parseFloat(
      cellValue?.toString()?.replace('-', '')?.trim()
    )?.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })})`;
  }
  return `$ ${parseFloat(
    cellValue?.toString()?.replace(',', '')?.trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
const unitsFormatter = (value) => {
  const cellValue = removeDollarForNumberFiled(
    removeCommaForNumberFiled(value || 0)
  )?.trim();
  if (cellValue < 0) {
    return ` (${parseFloat(
      cellValue?.toString()?.replace('-', '')?.trim()
    )?.toLocaleString('en-US', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    })})`;
  }
  return `${parseFloat(
    cellValue?.toString()?.replace(',', '')?.trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })}`;
};
const getTableRows = (rows, headerData) => {
  const dataToReturn = [];
  dataToReturn.push([
    {
      text: '',
      fontSize: contentFont,
      border,
    },
    {
      text: 'Invoice Amount',
      fontSize: contentFont,
      alignment: 'center',
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Units',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'URA',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Scripts',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Total Reimburse Amount',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Other Payments',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Principal Paid',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Units Paid',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Units Unpaid',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Units Disputed',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Disputed Amount',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Principal Due',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
    {
      text: 'Interest Due',
      alignment: 'center',
      fontSize: contentFont,
      color: 'black',
      bold: true,
      border,
    },
  ]);
  for (let i = 0; i < rows.length; i += 1) {
    dataToReturn.push([
      {
        text: [{ text: 'NDC: ' }, rows[i]?.ndc],
        fontSize: contentFont,
        color: 'black',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: [{ text: 'Drug Name: ' }, rows[i]?.drugName],
        fontSize: contentFont,
        color: 'black',
        colSpan: 4,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        color: 'black',
        colSpan: 1,
        alignment: 'left',
        border: [false, false, false, true],
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
    ]);
    dataToReturn.push([
      {
        text: 'Original:',
        fontSize: contentFont,
        color: 'black',
        alignment: 'left',
        border,
      },
      {
        text: valueFormatter(rows[i]?.originalInvoiceAmount),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalInvoiceAmount < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: unitsFormatter(rows[i]?.originalUnits),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalUnits < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: rows[i]?.originalURA,
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalURA < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: rows[i]?.originalInvoiceScripts,
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalInvoiceScripts < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.originalReimburseAmountOnClaims),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalReimburseAmountOnClaims < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.originalOtherpaymentsfromClaims),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.originalOtherpaymentsfromClaims < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
      {
        text: '',
        fontSize: contentFont,
        alignment: 'left',
        border,
      },
    ]);
    dataToReturn.push([
      {
        text: 'Current:',
        fontSize: contentFont,
        color: 'black',
        alignment: 'left',
        border,
      },
      {
        text: valueFormatter(rows[i]?.currentInvoiceAmount),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentInvoiceAmount < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: unitsFormatter(rows[i]?.currentUnits),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentUnits < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: rows[i]?.currentURA,
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentURA < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: rows[i]?.currentScripts,
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentScripts < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.currentReimburseAmountOnClaims),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentReimburseAmountOnClaims < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.currentOtherPaymentsfromClaims),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.currentOtherPaymentsfromClaims < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.principalPaid),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.principalPaid < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: unitsFormatter(rows[i]?.unitsPaid),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.unitsPaid < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: unitsFormatter(rows[i]?.unitsUnpaid),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.unitsUnpaid < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: unitsFormatter(rows[i]?.unitsDisputed),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.unitsDisputed < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.disputedAmount),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.disputedAmount < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.principalDue),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.principalDue < 0 ? '#a81f00' : 'black',
        border,
      },
      {
        text: valueFormatter(rows[i]?.interestDue),
        fontSize: contentFont,
        alignment: 'right',
        color: rows[i]?.interestDue < 0 ? '#a81f00' : 'black',
        border,
      },
    ]);
    if (rows.length - 1 === i) {
      dataToReturn.push([
        {
          text: 'Total:',
          fontSize: contentFont,
          color: 'black',
          alignment: 'left',
          bold: true,
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
      ]);
      dataToReturn.push([
        {
          text: 'Original:',
          fontSize: contentFont,
          color: 'black',
          alignment: 'left',
          bold: true,
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0].originalInvoiceAmount
          ),
          fontSize: contentFont,
          alignment: 'right',
          color:
            headerData?.pinnedBottomRowData[0].originalInvoiceAmount < 0
              ? '#a81f00'
              : 'black',
          border,
          bold: true,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'right',
          color: 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'right',
          color: 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'right',
          color: 'black',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0].originalReimburseAmountOnClaims
          ),
          fontSize: contentFont,
          alignment: 'right',
          color:
            headerData?.pinnedBottomRowData[0].originalReimburseAmountOnClaims <
            0
              ? '#a81f00'
              : 'black',
          border,
          bold: true,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0].originalOtherpaymentsfromClaims
          ),
          fontSize: contentFont,
          alignment: 'right',
          color:
            headerData?.pinnedBottomRowData[0].originalOtherpaymentsfromClaims <
            0
              ? '#a81f00'
              : 'black',
          border,
          bold: true,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
      ]);
      dataToReturn.push([
        {
          text: 'Current:',
          fontSize: contentFont,
          color: 'black',
          alignment: 'left',
          bold: true,
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.currentInvoiceAmount
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.currentInvoiceAmount < 0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.currentReimburseAmountOnClaims
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.currentReimburseAmountOnClaims <
            0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.currentOtherPaymentsfromClaims
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.currentOtherPaymentsfromClaims <
            0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.principalPaid
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.principalPaid < 0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'left',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.disputedAmount
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.disputedAmount < 0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: valueFormatter(
            headerData?.pinnedBottomRowData[0]?.principalDue
          ),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.principalDue < 0
              ? '#a81f00'
              : 'black',
          border,
        },
        {
          text: valueFormatter(headerData?.pinnedBottomRowData[0]?.interestDue),
          fontSize: contentFont,
          alignment: 'right',
          bold: true,
          color:
            headerData?.pinnedBottomRowData[0]?.interestDue < 0
              ? '#a81f00'
              : 'black',
          border,
        },
      ]);
    }
  }
  return dataToReturn;
};

const getTableBody = (bodyData, headerData) => {
  return [
    {
      style: 'tableExample',
      table: {
        headerRows: 1,
        widths: [44, 63, 63, 63, 60, 63, 63, 63, 63, 63, 63, 63, 63, 63],
        body: [...getTableRows(bodyData, headerData)],
      },
    },
  ];
};

const getPdfData = (bodyData, columns, headerData) => {
  const content = getTableBody(bodyData, headerData);
  const currentYear = new Date().getFullYear();
  return {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData, columns);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles: {
      myTable: {
        margin: [0, 0, 0, 0],
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        fontFamily: 'arial',
      },
      tableCell: {
        bold: false,
        fontSize: 10,
        fontFamily: 'arial',
      },
    },
    // pageOrientation: 'landscape',
    pageSize: {
      height: 700,
      width: 13 * 81,
    },
  };
};

export const exportPDF = (
  data,
  fileName,
  logInUser,
  columns,
  customObj,
  NDCBalance,
  pinnedBottomRowData,
  reportName,
  dispatch
) => {
  const headerData = {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy: logInUser,
    reportName: reportName,
    customObj,
    NDCBalance,
    pinnedBottomRowData,
  };

  const pdfData = getPdfData(data, columns, headerData);

  pdfMake.createPdf(pdfData).download(`${fileName}.pdf`);
  dispatch(dispatchTableLoader(false));
};
